import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import { FACULTY_ENDPOINT } from '../../../../../../utility/SourceAPI'

export const getFaculties = createAsyncThunk('appFaculty/getFaculties', async () => {
    const response = await axios.get(FACULTY_ENDPOINT)
    return {
        data: response.data
    }
})

export const addFaculty = createAsyncThunk('appFaculty/addFaculty', async (data) => {
    const response = await axios.post(FACULTY_ENDPOINT, data)
    return {
        data: response.data
    }
})

export const editFaculty = createAsyncThunk('appFaculty/editFaculty', async (data) => {
    const response = await axios.put(`${FACULTY_ENDPOINT}${data.id}`, data)
    return {
        data: response.data
    }
})

export const facultySlice = createSlice({
    name: 'appFaculty',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getFaculties.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
    }
})

export default facultySlice.reducer